/**
 * Target device viewport for milestone-1 web greybox.
 *
 * iPhone 17 Pro portrait CSS viewport (402×874) matches Safari's layout
 * viewport on that hardware. Corner radius follows the continuous display
 * curve reported by UIScreen (~62 pt on Pro models since iPhone 16 Pro).
 */

/** Portrait layout viewport width (CSS px). */
export const IPHONE_17_PRO_VIEWPORT_WIDTH = 402;

/** Portrait layout viewport height (CSS px). */
export const IPHONE_17_PRO_VIEWPORT_HEIGHT = 874;

/** Display corner radius in CSS points (portrait). */
export const IPHONE_17_PRO_CORNER_RADIUS = 62;
